<template>
	<div class="ReSearchObjBig" v-if="typeof objData !='undefined'">
		<div class="row mx-0 mb-4 justify-content-between align-items-center flex-shrink-1">
			<h2 class="mb-0">ЖК &laquo;{{objData.gk_name}}&raquo;</h2>
			<div class="bntGroup" >
				<!--
				<base-button type="primary" class="groupfloor" simple @click="toSearchObj()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined' && typeof $GVO.GetAllGet().taskend_id !=0"><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
				<base-button type="primary" class="groupfloor" simple @click="toSearchObjRegular()" v-else><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
				-->
				<base-button type="primary" class="groupfloor" simple @click="backByHistory()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined' && typeof $GVO.GetAllGet().taskend_id !=0"><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
				<base-button type="primary" class="groupfloor" simple @click="backByHistory()" v-else><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
			</div>
			
		</div>
		<!--pre>{{objData}}</pre-->
		<card>
			<div class="objectsFlats">             
				<tabs type="primary" 
					tabContentClasses="tab-opt"
					centered
					inline
					round			
					class="card card-plain mt-3"
					:activeTab="value"
					v-loading.fullscreen.lock="fullscreenLoading"
					element-loading-text="Загрузка данных..."
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)"
					@change="OnTabChange">
					<tab-pane :id="'flat_list'">
						<template v-slot:label>
							<span class="tab-label">
								<i class="tab-icon tim-icons icon-align-left-2"></i><span>Список</span>
							</span>
						</template>
						<div class="flatsList mb-3" v-for="(masCorps, dt) in objCorpDTEnds" :key="dt">
							<div class="flatsList-title">
								<h4 class="mr-5">Срок сдачи: <span>{{$GVO.convertDateFromMysql(dt)}}</span></h4>
								<h4>Корпус: {{PrintCorps(masCorps)}}</h4>
							</div>

							<collapse v-for="(kkv, key) in objFlatsData[dt]" :key="dt+'_'+key">
								<collapse-item :title="getFlatsTitle(objFlatsPrintData[dt][key])" >
									<div class="">
										<el-table :data="kkv" @row-click="GoToFlat" :highlight-current-row="true">
											<el-table-column
												min-width="100"
												sortable
												label="Корп"
												property="b_corp"
											></el-table-column>
											<el-table-column
												min-width="100"
												sortable
												:sort-method="sortInt_app_flatfloor"
												label="Этаж"
												property="app_flatfloor"
											></el-table-column>
											<el-table-column
												min-width="100"
												sortable
												:sort-method="sortInt_app_number"
												label="№"
												property="app_number"
											></el-table-column>
											<el-table-column
												min-width="130"
												sortable
												:sort-method="sortFloat_app_stotal"
												label="S общая"
												property="app_stotal"
											></el-table-column>
											<el-table-column
												min-width="130"
												sortable
												:sort-method="sortFloat_app_skitchen"
												label="S кухни"
												property="app_skitchen"
											></el-table-column>
											<el-table-column
												min-width="150"
												sortable
												label="Отделка"
												property="app_decoration"
											></el-table-column>
											<el-table-column
												min-width="220"
												sortable
												:sort-method="sortInt_app_flatcostwithdiscounts"
												label="Цена при 100% оплате"
											>
												<template v-slot="scope">
													{{$GVO.formatAmount(parseFloat(scope.row.app_flatcostwithdiscounts))}}
												</template>
											</el-table-column>
											<el-table-column
												min-width="150"
												sortable
												:sort-method="sortInt_app_metrecostwithdiscounts"
												label="Цена за м2"
											>
												<template v-slot="scope">
													{{$GVO.formatAmount(parseFloat(scope.row.app_metrecostwithdiscounts))}}
												</template>
											</el-table-column>
											<el-table-column
												min-width="130"
												sortable
												:sort-method="sortInt_sold"
												label="Статус"
											>
												<template v-slot="scope">
													<span :class="[{'text-success':scope.row.sold==1},{'text-danger':scope.row.sold==0},{'text-warning':scope.row.sold==1 && scope.row.app_stat==3}]">
														{{sold(scope.row)}}
													</span>														
												</template>
											</el-table-column>
										</el-table>
									</div>
								</collapse-item>
							</collapse>            
						</div>
					</tab-pane>

					<tab-pane :id="'flat'">
						<template v-slot:label>
							<span class="tab-label">
								<i class="tab-icon tim-icons icon-components"></i><span>Планировки</span>
							</span>
						</template>
						<div class="card-wrapper ">
							<div class="flatsLayout card-wrapper-center  row px-3" v-if="value == 'flat'">
								<h3 v-if="!bIsLoading && Object.keys(objFlatsData).length==0">Ничего не найдено</h3>
								<template v-else>
									<ReSearchObjGrouping v-for="flat in objFlatsData" :key="flat.id" :objData="flat"/>
								</template>
							</div>
						</div>
					</tab-pane>

					<tab-pane :id="'chess'" >
						<template v-slot:label>
							<span class="tab-label">
								<i class="tab-icon tim-ic ic-chess"></i><span>Шахматка</span>
							</span>
						</template>
						<div class="flatsGrid">
							<h3 v-if="!bIsLoading && Object.keys(objFlatsData).length==0">Ничего не найдено</h3>
							<template v-else>
								<ReSearchFlatsGrid v-if="typeof objFlatsPrintData != 'undefined' && !$GVO.isEmpty(objFlatsPrintData)" :objData="objFlatsData" :objFlatsPrintData="objFlatsPrintData"/>
							</template>
							                                
						</div>
					</tab-pane>
				</tabs>
			</div> <!--objectsFlats  фильтруемый контент-->

			<div class="row objectHeader mb-3">
				<div class="col-sm-12 col-md-4 mt-2 objectPhotos">
					<div>
						<el-carousel :autoplay="false" arrow="always" height="250px" v-if="objData.ComplexImages !='' && typeof objData.ComplexImages != 'undefined'">
							<el-carousel-item v-for="gk_img in objData.ComplexImages" :key="gk_img.id">
								<img :src="`/DATA/complex_files/NewComplexFiles/${gk_img.filename}`" alt=""> 
							</el-carousel-item>
						</el-carousel>
						<div>
							<img v-if="objData.ComplexImages == ''" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
						</div>
					</div>
					
				</div>

				<div class="col-sm-12 col-md-4 mt-2 pl-4 objectInfo"> 
					<div class="row justify-content-between px-3">
						<h4>ЖК &laquo;{{objData.gk_name}}&raquo;</h4>
						<h4>от {{$GVO.formatAmount(parseFloat(objData.min_amount_on_sale))}}</h4>                     
					</div>
					<div class="text-left mb-3"><p>Квартир в комплексе: {{objData.countflat_onsale}}</p></div>                 
						
					<div class="metro">
						<div class="row flex-nowrap ml-0 mr-2 align-items-top">
							<i class="tim-ic ic-metro text-primary mr-1"></i>
							<p>{{$GVO.str_replace(',',', ',objData.metro_name)}},</p>
						</div> 
						<div class="row ml-0 mr-2 align-items-center">
							<i class="metroIc tim-icons icon-user-run text-primary"></i> 
							<p>{{objData.metro_distance}} мин.,</p>									
						</div> 
						<div class="row mx-0 align-items-center">
							<i class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
							<p>{{objData.metro_distance_transport}} мин.</p>									
						</div> 								
					</div>
					<div class="objectAddress"><p>{{objData.dis_name}}, {{objData.gk_street}} </p></div> <!--тут же должен быть номер дома, но его нигде не нашли-->                                                     
					<div class="text-left my-3" v-if="objData.DevCurator != undefined && objData.DevCurator.length > 0 ">
					    <h4>Информация о кураторах</h4>
					    <ul class="list-unstyled result-marker" id="dev_cur_info" v-for="DEVC in objData.DevCurator" :key="DEVC.id">
							<li v-for="Curator in $GVO.SafeParseJson(DEVC.staff_codes)" :key="Curator.value">	
								<router-link :to="'/data/staff/id/'+Curator.value"> {{ Curator.label }} </router-link>	  
							</li>
					    </ul>
					</div>                 
				</div>

				<div class="col-sm-12 col-md-4 objectPass px-4">
					<collapse activeIndexType="all">
						<collapse-item title="Паспорт объекта">
							<div class="objectPass-container">
								<div class="object-row objDots"><p>Сроки сдачи</p><span></span><p>{{$GVO.convertDateFromMysql(objData.b_endingperiod_min)}}</p></div>
								<div class="object-row objDots"><p>Застройщик</p><span></span><p>&laquo;{{objData.dev_name}}&raquo;</p></div>
								<div class="object-row objDots"><p>Тип дома</p><span></span><p>{{objData.b_buildingtypes}}</p></div>
								<!--div class="object-row objDots"><p>Фасад</p><span></span><p>Штукатурка и т.п. (нет данных - Куратор)</p></!--div-->
								<div class="object-row objDots"><p>Отделка</p><span></span><p>{{$GVO.str_replace(',',', ',objData.b_decoration_list)}}</p></div>
								<!--div class="object-row objDots"><p>Договор</p><span></span><p>ДДУ, ПДКП, КП, Цессии ДДУ (нет данных - Куратор)</p></!--div-->
								<div class="pay-row objDots">
									<p >Оплата</p>
									<span></span>
									<div  class="objectPass-row text-right">
										<p v-if="objData.b_mortgage_flag == 1">Ипотека</p>
										<p v-if="objData.b_militarymortgage_flag == 1">Военная ипотека</p>
										<p v-if="objData.b_subsidy_flag == 1">Субсидии</p>
										<p v-if="objData.b_maternitycapital_flag == 1">Материнский капитал</p>
										<p v-if="objData.b_installment_flag == 1">Рассрочка</p>	
									</div>					
								</div>
							</div>
						</collapse-item>
						<collapse-item title="Информация для агента" class="mt-4" v-if="typeof objData.DevExtraData[0] != 'undefined' && objData.DevExtraData[0] != ''">
							<div class="dev-info">
								<p v-if="typeof objData.DevExtraData[0] != 'undefined' && objData.DevExtraData[0] != ''">Комиссия: от {{objData.DevExtraData[0].min_commission}} % до {{objData.DevExtraData[0].max_commission}} %</p>
								<p v-if="objData.DevExtraData[0].ads == 0">Реклама: да</p>
								<p v-if="objData.DevExtraData[0].ads == 1">Реклама: нет</p>
								<p v-if="objData.DevExtraData[0].ads == 2">Реклама: с ограничениями</p>
								<p v-if="objData.DevExtraData[0].ads == 2">Ограничения: {{$GVO.str_replace(',',', ',objData.DevExtraData[0].restriction_names)}}</p>
								
							</div>
						</collapse-item>
					</collapse>            
				</div>

			</div>

			<div class="gkFiles" v-if="objData.ComplexFiles.length>0 || objData.DevFiles.length>0">
				<div class="bntGroup col-sm-12 col-md-4 px-0">
					<base-button type="primary" simple @click="showGKFiles()"> <i class="tim-ic ic-folder mr-2"></i>Файлы ЖК</base-button>
				</div>

				<div class="gkFiles-content" v-show="filesHidden">
					<div class="col-md-6 Dev-collapse" v-if="objData.DevFiles.length>0">
						<collapse>
							<collapse-item title="Файлы застройщика">
								<div class="col px-0">
									<!--pre v-for="objDevFile in objData.DevFiles">{{objDevFile}}</pre-->
									<a :href="objDevFile.filepath" target="_blank" class="file-link mb-2" v-for="(objDevFile, el_index) in objData.DevFiles" :key="el_index">{{objDevFile.filename}}</a>

								</div>
							</collapse-item>
						</collapse>
					</div>
					<div class="col-md-6 GK-collapse" v-if="objData.ComplexFiles.length>0">
						<collapse>
							<collapse-item title="Файлы комплекса">
								<div class="col px-0">
									<div v-for="(masFiles,strFolder) in objComplexFiles" class="mb-3" :key="strFolder">
										<p>{{strFolder}}</p>
										<!--pre v-for="objFile in masFiles">{{objFile}}</pre-->
										<a :href="objFile.filepath" target="_blank" class="file-link mb-2 ml-3" v-for="(objFile, el_index) in masFiles" :key="el_index">{{objFile.filename}}</a>
									</div>
								</div>
							</collapse-item>
						</collapse>
					</div>
				</div>
			</div>

			<div class="objectMain mt-4">
				<div class="objectDscrpt">
					<div class="description col col-md-8">
						<h4>Описание</h4>
						<p>{{objData.gk_note}}</p>
					</div>
					<div v-if="objData.PlusMinus.length>0">
						<div  class="col advantages">
							<h4>Преимущества</h4>
							<template v-for="point in objData.PlusMinus" >
								<div v-if="point.type == 1" :key="point.id" class="adv-row"><i class="tim-ic ic-advantage text-primary mr-2"></i><p v-html="stripHtmlTags(point.text)"></p></div> 
							</template>
						</div>
						<!--div  class="col disadvantages mt-3">
							<h4>Недостатки</h4>
							<template v-for="point in objData.PlusMinus">
								<div v-if="point.type == 0" :key="point.id" class="adv-row"><i class="tim-ic ic-disadvantage text-danger mr-2"></i><p v-html="stripHtmlTags(point.text)"></p></div>
							</template>
						</div-->
					</div>
				</div>

				<div class="objectMap">
					<h4>Местоположение</h4>
					<div v-if="typeof objData.gid != 'undefined' && objData.gid != ''" class="map embed-responsive embed-responsive-16by9"></div>
					<div v-else class="map">
						<yandex-map
							:settings="yamap_settings"
							:coords="yamap_coords"
							:zoom="yamap_zoom"
							:scroll-zoom="false"
							:controls="yamap_controls"
							>
						
							<ymap-marker
									:coords="yamap_markers.coords"
									:marker-id="yamap_markers.id"
									marker-type="placemark"
							/>

						</yandex-map>
					</div>
				</div> <!--objectMap  заглушка-->

				<div class="objectPanorama" v-if="typeof objData.pano != 'undefined' && objData.pano !=''">
					<h4>Аэропанорама</h4>
					<div class="map embed-responsive embed-responsive-16by9">
						<iframe :src="objData.pano+'?show_card=no&show_builder_name=no&show_realty_name=no'" :data-pano-src="objData.pano+'?show_card=no&show_builder_name=no&show_realty_name=no'" width="100%" height="600" allowFullScreen="true" frameborder="0"></iframe>
					</div>
				</div> <!--objectPanorama  заглушка-->

				<!--div class="objectProgress">
					<h4>Ход строительства (В разработке. Нужны данные Куратора.)</h4>
					<div class="pic-filter">
						<ReDateRange/>
						<div class="bntGroup ml-3">
							<base-button type="success" simple>Показать</base-button>
						</div>
					</div>
					<el-carousel :autoplay="false" arrow="always" type="card" height="250px">
						<el-carousel-item v-for="item in 4" :key="item">
							<div class=""></div>
						</el-carousel-item>
					</el-carousel>
				</div--> <!--objectProgress  заглушка-->

				<div class="banks">
					<h4>Аккредитован банками</h4>
					<div class="bank-row">                        
						<!--ReBankSmall v-for="bank in objData.ComplexBank" :key="bank.id"/-->
						<div v-for="bank in objData.ComplexBank" :key="bank.id" class="ReBankSmall col-sm-6 col-md-4 col-lg-3 col-xl-2">
							<div class="bank-col mb-3">
								<div class="bank-logo">
									<!--img src="/img/placeholder.jpg" alt="" class="logo-img"-->
									<img :src="`/DATA/${bank.logo_to_site}`" alt="" class="logo-img">
								</div>   
								<div class="bank-title">
									<h4 class="mb-0 text-primary">{{bank.bankname}}</h4>
									<p>&laquo;{{bank.programname}}&raquo;</p>
								</div>                         
							</div>
							<div class="bank-col">
								<p>Первый взнос  от {{bank.firstpaypercentmin}} %</p>
								<p>Ставка  от {{bank.ratepercent}} %</p>
								<p>Срок ипотеки до {{bank.periodmax}} лет</p>           
							</div>                                             
						</div>

					</div>
				</div> 
			</div> <!--objectMain-->
		</card>

	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Carousel, CarouselItem, } from "element-ui";	
import { TabPane, Tabs } from 'src/components';
import { Table, TableColumn } from 'element-ui';
import ReSearchObjGrouping from 'src/our_modules/SearchSendObjects/ReSearchObjGrouping.vue'; 
import ReSearchFlatsGrid from 'src/our_modules/SearchSendObjects/ReSearchFlatsGrid.vue'; 
// import ReDateRange from 'src/our_components/ReDateRange.vue'; 
// import ReBankSmall from 'src/our_modules/SearchSendObjects/ReBankSmall.vue'; 
import moment from 'moment';
// import VueMoment from 'vue-moment';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import mapSettings from 'src/conf/yandexmap.js';
import BaseButton from '../components/BaseButton.vue';

export default {
	name: 'ReSearchObjBig',
	components: {
		Collapse,
		CollapseItem,
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		TabPane, 
		Tabs,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		ReSearchObjGrouping,		
		ReSearchFlatsGrid,
		// ReDateRange,
		// ReBankSmall,
		yandexMap, ymapMarker,
		BaseButton,
		//Loading,
	},
	props: {
		objData: Object,
		objFlatsData: Object,
		objFlatsPrintData: [Object, String, Array],
		bIsLoading: {
			type: Boolean,
			default: false
		},		
		value: {
			type: String,
			default: 'flat_list', // flat_list||flat||chess
		},
		
	},
	data () {
		return {
			ver: 1,   
			yamap_settings: { ...mapSettings },
			yamap_coords: [59.93984485554249, 30.314527237792984],
			yamap_zoom: 17,
			yamap_controls:['zoomControl','typeSelector'],
			yamap_markers:{
				coords: [59.93984485554249, 30.314527237792984],
				id: '1',
			},
			bIsObjects: true,
			fullscreenLoading: false,	
			masDevs: [],
			filesHidden: false,
			objComplexFiles: {},
			masRestr: [],
		}    
	},
	watch: {
		objData: function(newData){
			this.yamap_coords = [newData.gk_lat, newData.gk_lot];
			this.yamap_markers.coords = [newData.gk_lat, newData.gk_lot];
		}
	},
	computed: {
		objCorpCat: function(){
			let objRet = this.$GVO.SafeParseJson(this.objData.b_corps_name);
			return objRet;
		},
		objCorpEnds: function(){
			let objRet = {};
			//"Корп.: 4.13###2021-12-30###Korp413,Корп.: 4.15###2021-12-30###Korp415,Корп.: 4.13###2023-06-30###Korp413,Корп.: 4.15###2023-06-30###Korp415"
			const masDmp = this.objData.b_endingperiod_list.split(',');
			//console.log(masDmp);
			for (let i = 0; i < masDmp.length; i++) {
				const masInDmp = masDmp[i].split('###');
				//console.log(masInDmp);
				if(masInDmp.length == 3){
					if(typeof objRet[masInDmp[2]] == 'undefined'){
						objRet[masInDmp[2]] = {
							name: masInDmp[0],
							dt_end: masInDmp[1],
							id: masInDmp[2]
						}
					}
				}
			}
			//console.log(objRet);
			return objRet;
		},
		objCorpDTEnds: function(){
			let objRet = {};
			for (const corp_id in this.objCorpEnds) {
				if (this.objCorpEnds.hasOwnProperty(corp_id)) {
					const objCorp = this.objCorpEnds[corp_id];
					if(typeof objRet[objCorp.dt_end] == 'undefined')objRet[objCorp.dt_end] = [];
					objRet[objCorp.dt_end].push(objCorp);
				}
			}
			let objDmp = {};
			Object.keys(objRet).sort(function (a, b) {
				return moment(a).isAfter(b) ? 1:-1;
			}).forEach(function (k_dt) { objDmp[k_dt] = objRet[k_dt]; });
			return objDmp;
		},		
	},
	methods: {
		sortInt_app_number(a,b){
			return parseInt(a.app_number) - parseInt(b.app_number);
		},
		sortInt_app_flatfloor(a,b){
			return parseInt(a.app_flatfloor) - parseInt(b.app_flatfloor);
		},
		sortFloat_app_stotal(a,b){
			if(b.app_stotal == '') b.app_stotal = 0;
			if(a.app_stotal == '') a.app_stotal = 0;
			return parseFloat(a.app_stotal) - parseFloat(b.app_stotal);
		},
		sortFloat_app_skitchen(a,b){
			if(b.app_skitchen == '') b.app_skitchen = 0;
			if(a.app_skitchen == '') a.app_skitchen = 0;
			return parseFloat(a.app_skitchen) - parseFloat(b.app_skitchen);
		},
		sortInt_app_flatcostwithdiscounts(a,b){
			return parseInt(a.app_flatcostwithdiscounts) - parseInt(b.app_flatcostwithdiscounts);
		},
		sortInt_app_metrecostwithdiscounts(a,b){
			return parseInt(a.app_metrecostwithdiscounts) - parseInt(b.app_metrecostwithdiscounts);
		},
		sortInt_sold(a,b){
			return parseInt(a.sold) - parseInt(b.sold);
		},
		GoToFlat(rowData){
			// console.log(rowData);
			let objGetParams = this.$GVO.GetAllGet();
			let strItogGetParams = ''
			if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
				strItogGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
			}
			//this.$router.push({path: `/data/module/sso/object/flat/${rowData.app_id}${strItogGetParams}`});
			location.href = `/data/module/sso/object/flat/${rowData.app_id}${strItogGetParams}`;
		},
		sold(row){
			if (parseInt(row.sold) == 1){
				if(parseInt(row.app_stat) == 3){
					return 'Забронировано';
				}else{					
					return 'В продаже'; 
				}
			}else{
				return 'Продано';
			}
		},
		OnTabChange(strTabId){
			this.$emit('input', strTabId);
			this.$emit('change', strTabId);
			this.openFullScreen1();
		},
		PrintCorps(masCorps){
			let masRet = [];
			for (let i = 0; i < masCorps.length; i++) {
				masRet.push(masCorps[i].name);
			}
			return masRet.join(', ');
		},
		getFlatsTitle(objFlatPrintData){
			let strRet = '';
			//console.log(objFlatPrintData);
			return `${objFlatPrintData.kkv} от ${objFlatPrintData.sTotal} м2 от ${this.$GVO.formatAmount(parseFloat(objFlatPrintData.amount))} Квартир ${objFlatPrintData.count_app}`;
		},
		stripHtmlTags(str){
			if ((str===null) || (str===''))
				return false;
			else  str = str.toString().replace((/<[^>]+>/g) || (/&([^;]+);/g), '');  
			return str;
		},
		backByHistory(){
			this.$router.back();
		},
		toSearchObj(){
			const objGetParams = this.$GVO.GetAllGet();
			location.href=`/data/module/sso?=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
		},
		toSearchObjRegular(){	
			//const objGetParams = this.$GVO.GetAllGet();		
			location.href=`/data/module/sso`;
			//object/complex/${objData.gk_name_tr}
		},
		openFullScreen1() {
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		showGKFiles(){
			this.filesHidden = !this.filesHidden;
			this.objComplexFiles = {};
			if (this.objData.ComplexFiles.length>0) {
				for (let i = 0; i < this.objData.ComplexFiles.length; i++) {
					let strFolder = this.folderName(this.objData.ComplexFiles[i].filepath);
					if(typeof this.objComplexFiles[strFolder] == 'undefined'){
						this.objComplexFiles[strFolder] = [];
					}
					this.objComplexFiles[strFolder].push(this.objData.ComplexFiles[i]);
				}
			}

		},
		folderName(strFullPath){
			let masPath = strFullPath.split('/');
			return masPath[masPath.length-2];
		},/*
		masRestriction(){
			let masRestr = this.objData.DevExtraData[0].restriction_names.split(',');
			for (let i = 0; i < masRestr.length; i++) {
					let el = masRestr[i];					
				
					return el;
				} 
			
		},*/
		
		
	},
	mounted(){
		/*
		var _pf=document.getElementsByTagName("iframe");
		for(var i=0; i<_pf.length;i++){
			if(_pf[i].getAttribute('data-pano-src'))
				_pf[i].setAttribute('src',_pf[i].getAttribute('data-pano-src'));
		}
		*/
		if(typeof this.objData != 'undefined'){
			this.yamap_coords = [this.objData.gk_lat,this.objData.gk_lot];
			this.yamap_markers.coords = [this.objData.gk_lat,this.objData.gk_lot];
		};
	},
}
</script>
<style scoped>
.ReSearchObjBig >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReSearchObjBig >>> .tab-content {margin-top: 15px;}

.flatsList, .objectDscrpt, .objectMap, .objectPanorama, .objectProgress, .banks {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px;}
.objectDscrpt, .objectMap, .objectPanorama, .objectProgress {margin-bottom: 20px;}

.objectInfo h4 {margin-bottom: 5px;}
.objectPhotos .bntGroup > button {width: 100%; margin-top: 20px;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.objectPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.gkFiles >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.objectPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.objectPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.objectPass-container {display: flex; flex-direction: column;}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row p:first-child {/*min-width: 100px;*/ margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {padding-left: 5px; margin-left: 10px;}
.pay-row  p {position: relative; text-align: right;}
.objectPass-row p::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -5px;
	top: 9px;
} 
.objectPass-container  p:not(:first-child) {padding-left: 5px; text-align: right;}
.pay-row {display: flex; justify-content:space-between;}

/*===flats===============================*/

.flatsList-title {display: flex; border-bottom: 1px solid #01b0e0;}
.flatsList >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}

/*===carousel===============================*/

.ReSearchObjBig >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.ReSearchObjBig >>>  button:focus {outline: none!important;}
.ReSearchObjBig >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.ReSearchObjBig >>> .el-carousel__arrow--right {right: 0;}
.ReSearchObjBig >>> .el-carousel__arrow--left {left: 0;}
.objectPhotos img {height: 100%; border: 1px solid transparent; margin: 0 auto; display: block; object-fit: contain;}

.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/modules/l_62252220433d741e4b44abe1e65fb24a.jpg") no-repeat center;
  background-size: contain;
}
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/bg3.jpg") no-repeat center;
  background-size: contain;
}


/*===table===============================*/

.ReSearchObjBig >>> .el-table table {margin-bottom: 0px;}
.flatsList >>>  .card-body {padding: 0px;}
.flatsList >>>  .card-collapse .card:not(.card-cinc) .card-body {padding: 0px;}
.ReSearchObjBig >>> .tab-space {padding: 20px 0 15px 0px;}


/*===object Description===============================*/

.objectDscrpt {display: flex;}
.adv-row {display: flex; margin-bottom: 3px;}
.icon-adv {height: 18px; width: 18px; background-image: url('/img/icons/advantage.svg'); margin: 2px 10px 0px 0px; padding: 0 8px;}
.icon-disadv {height: 18px; width: 18px; background-image: url('/img/icons/disadvantage.svg'); margin:  2px 10px 0px 0px; padding: 0 8px;}
.disadvantages {display: block;}
.objectDscrpt .col, .objectDscrpt .col-md-8 {padding: 0px 15px 0px 5px;}

/*===ReBankSmall===============================*/

.ReBankSmall {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px; margin-bottom: 20px; display: flex; flex-direction: column; justify-content: space-between;}
.ReBankSmall:not(:last-child) {margin-right: 20px;}
.bank-logo {max-width: 100px; margin: 0 auto;}
.logo-img {object-fit: contain;}
.bank-logo img {width: 100%; margin-bottom: 10px;}
.bank-title {display: flex; flex-direction: column;}


.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}
.flatsGrid h3 {text-align: center;}


.gkFiles-content {display: flex; height: auto; flex-wrap: wrap;}
.file-link {border-bottom: 1px solid #01b0e0; display: block;}
.gkFiles .bntGroup {align-items: center; justify-content: center; display: flex;}
.gkFiles .bntGroup .btn {width: 100%; margin-right: 20px;}

/*===media===============================*/
@media (max-width: 768px) {	
	.objectDscrpt {flex-direction: column;}
	.advantages , .disadvantages {margin-top: 10px;}
	.objectPass {margin-top: 15px;}
	.ReBankSmall {margin-right: 0px;}
	.flat .row {width: 100%; margin-left: 0px;}
	.gkFiles .bntGroup .btn {margin-right: 0px;}
}

.pic-filter {display: flex; margin-bottom: 20px;}
.ReSearchObjBig >>> .el-input__inner {background: transparent; border: 1px solid #01b0e0;}
.ReSearchObjBig >>>  .el-input__inner:focus {border: 1px solid #01b0e0;}

.bank-row {display: flex; flex-wrap: wrap; /*justify-content: space-between;*/}
.bank-col {display: flex; flex-direction: column; justify-self: flex-end;}
.bank-col p {margin-bottom: 0px;}
.ReSearchObjBig .map {height: 600px;}
.ReSearchObjBig >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}

</style>
